import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Navigation } from 'app/core/navigation/navigation.types';
import { environment } from 'environments/environment';
import { BaseRespone } from '../models/common.response';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { items } from 'app/mock-api/apps/file-manager/data';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<any>(`${environment.baseUrl}/User/navigation`).pipe(
            tap((navigation) => {
                const navigation1: Navigation = this.buildNavigationStructure(navigation.result);
                this._navigation.next(navigation1);
            })
        );
    }

    buildNavigationStructure(items: FuseNavigationItem[]): Navigation {
        return {
            default: items,
            compact: items,
            futuristic: items,
            horizontal: items,
        };
    }

    buildEmptyStructure(items: FuseNavigationItem[]): FuseNavigationItem[] {
        return items.map(item => ({
            id: item.id,
            title: item.title,
            type: item.type,
            icon: item.icon,
            target: item.target,
            children: item.children ? [] : undefined // empty children for compact/futuristic
        }));
    }
}
